/**
 * Pollo Wan 2.5 Preview：input 结构单独封装
 * 图生：image 必填，resolution 480P|720P|1080P，length 5|10|15，wanAudio 默认 true
 * 文生：prompt 必填，resolution + aspectRatio，length 5|10|15，wanAudio
 * 共用：negativePrompt、seed、audioUrl（可选）
 */
import { isUrl } from './utils'

var RES_MAP = { '480p': '480P', '480P': '480P', '720p': '720P', '720P': '720P', '1080p': '1080P', '1080P': '1080P' }

function normalizeResolution(v) {
  if (!v) return '1080P'
  var key = String(v).trim()
  return RES_MAP[key] || '1080P'
}

function normalizeLength(v) {
  var n = parseInt(v, 10)
  if (n === 10 || n === 15) return n
  return 5
}

export function buildBody(params) {
  var hasImage = isUrl(params.referenceImage)
  var input = {
    prompt: (params.prompt || '').trim().slice(0, 2000),
    negativePrompt: (params.negativePrompt || '').trim().slice(0, 500) || undefined,
    length: normalizeLength(params.videoDuration || params.length || 5),
    resolution: normalizeResolution(params.videoRes || params.resolution),
    wanAudio: params.wanAudio === true
  }
  var seed = params.seed != null && params.seed !== '' && params.seed !== -1 ? parseInt(params.seed, 10) : null
  if (seed != null && !isNaN(seed) && seed <= 2147483647) input.seed = seed
  if (params.audioUrl && isUrl(params.audioUrl)) input.audioUrl = params.audioUrl.trim()
  if (hasImage) {
    input.image = params.referenceImage.trim()
  } else {
    input.aspectRatio = (params.aspectRatio || '16:9').replace(/：/g, ':')
  }
  var body = { input: input }
  if (params.webhookUrl && isUrl(params.webhookUrl)) body.webhookUrl = params.webhookUrl
  return body
}
